import styled, { css } from 'styled-components';
import theme from 'v3/theme';

export const Timeline = styled.div`
  --count: ${(p) => p.$count || 1};

  --dot: clamp(8px, 1.4vw, 14px);
  --gap: clamp(10px, 2vw, 24px);

  position: relative;
  width: 100%;
  padding: 18px 16px;
  display: grid;
  grid-template-columns: repeat(var(--count), 1fr);
  column-gap: var(--gap);
  align-items: center;

  &::before {
    content: '';
    position: absolute;
    left: 16px;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    border-top: 2px dashed ${theme.colors.medium_gray};
    z-index: 0;
  }

  ${(p) =>
    p.$count > 16 &&
    css`
      --gap: 10px;
    `}
`;

Timeline.City = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  z-index: 1;

  &:first-child {
    justify-content: flex-start;
  }
  &:last-child {
    justify-content: flex-end;
  }
`;

Timeline.Marker = styled.div`
  width: var(--dot);
  height: var(--dot);
  border-radius: 50%;
  background-color: ${theme.colors.medium_gray};
  cursor: pointer;
`;

Timeline.Last = styled(Timeline.Marker)`
  width: calc(var(--dot) + 6px);
  height: calc(var(--dot) + 6px);
`;

Timeline.Name = styled.div`
  position: absolute;
  top: calc(-1 * (var(--dot) + 20px));
  background: #f2f2f2;
  border-radius: 20px;
  padding: 5px 10px;
  white-space: nowrap;
  opacity: 0;
  transform: translateY(8px);
  transition: opacity 0.15s ease, transform 0.15s ease;
  pointer-events: none;

  ${Timeline.City}:nth-child(2n) & {
    top: auto;
    bottom: calc(-1 * (var(--dot) + 22px));
    transform: translateY(-8px);
  }

  ${Timeline.City}:hover & {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const RemainingDistanceWarning = styled.span`
  border: 3px solid red;
  padding: 0.5rem 1.5rem;
  align-self: center;
  margin: 0.5rem 0 0;
  color: red;
  position: relative;
  top: -1.5rem;
  left: -1rem;
  font-size: 0.85rem;
`;
